module.exports = __webpack_public_path__ + "static/media/ontology.38f582de.svg";